// Shipment status constants - shared across cmsPrograms and shipmentFields
// This file should have no imports to avoid circular dependencies

export const shipmentStatusEnum = {
  new: 'new',
  created: 'created',
  in_transit: 'in_transit',
  delivered: 'delivered',
  cancelled: 'cancelled',
};
